// extracted by mini-css-extract-plugin
module.exports = {"pagination":"SimplePagination_pagination__2hW80","wrapper":"SimplePagination_wrapper__5sckz","pageSize":"SimplePagination_page-size__1pwdk","items":"SimplePagination_items__2PIlw"};